const Builder = require('../BuilderBase');
const CustomizableVisibility = require('../CustomizableVisibility');

module.exports = class ActionButton extends Builder {
    constructor(title, properties) {
        super('actionElement_Button', title, properties);
    }

    /**
     *
     * @param {object} properties
     * @param {string} properties.title
     * @param {boolean} properties.isTabAccess
     * @param {string} properties.accessTargetId
     * @param {boolean} properties.readOnly
     */
    customizableVisibility(properties) {
        let modifier = new CustomizableVisibility(properties);
        this.addChildBlock(modifier, 'securityModifier');
        return this;
    }
};
